export const ACCOUNT_LEVEL_PARENT = 'PARENT_ACCOUNT'
export const ACCOUNT_LEVEL_SUB = 'SUB_ACCOUNT'
export const ACCOUNT_LEVEL_PARENT_AND_SUB = 'PARENT_AND_SUB_ACCOUNT'

export type AccountLevelDisplay = {
  label: string
  badgeClass: string
}

export const accountLevelFilterOptions = [
  {value: '', label: 'All'},
  {value: ACCOUNT_LEVEL_PARENT, label: 'Parent Account'},
  {value: ACCOUNT_LEVEL_SUB, label: 'Sub-Account'},
]

const ACCOUNT_LEVEL_MAP: Record<string, AccountLevelDisplay> = {
  [ACCOUNT_LEVEL_PARENT]: {label: 'Parent Account', badgeClass: 'account-level-badge-parent'},
  [ACCOUNT_LEVEL_SUB]: {label: 'Sub-Account', badgeClass: 'account-level-badge-sub'},
  [ACCOUNT_LEVEL_PARENT_AND_SUB]: {
    label: 'Parent, Sub Account',
    badgeClass: 'account-level-badge-parent',
  },
}

const UNKNOWN_ACCOUNT_LEVEL: AccountLevelDisplay = {
  label: 'Unknown',
  badgeClass: 'account-level-badge-unknown',
}

export const getAccountLevelDisplay = (accountLevel?: string): AccountLevelDisplay | undefined =>
  accountLevel ? ACCOUNT_LEVEL_MAP[accountLevel] ?? UNKNOWN_ACCOUNT_LEVEL : undefined

export const accountLevelFromParent = (parentAccountId?: number | null): string =>
  parentAccountId ? ACCOUNT_LEVEL_SUB : ACCOUNT_LEVEL_PARENT
